import React, { useRef } from 'react'
import { Box, Typography } from '@mui/material'
import { DefinitionsTopical, DefinitionsTopicalHandle } from '../topic/definitions';
import { DefinitionsOral, DefinitionsOralHandle } from '../oral/definitions';
import { FlowType } from "../flow-type";
import { ChoiceChips, WizardShell } from '../../../../components/ui';
import { TOPIC_STEPS, ORAL_STEPS } from '../wizard-steps';
import { getQuery } from '../../../../services/local-session-storage';

// ----------------------------------------------------------------------

type Props = {
    flowType: FlowType
    onFlowTypeChange: (type: FlowType) => void
    onBack: () => void
    onFinish: () => void
}

const FLOW_OPTIONS = [
    { value: 'topic' as FlowType, label: 'Tópica' },
    { value: 'oral' as FlowType, label: 'Oral' },
]

export const Definitions: React.FC<Props> = ({ flowType, onFlowTypeChange, onFinish, onBack }) => {
    const topicalRef = useRef<DefinitionsTopicalHandle>(null)
    const oralRef = useRef<DefinitionsOralHandle>(null)
    const model = getQuery()

    const handleNext = () => {
        if (flowType === 'topic') {
            topicalRef.current?.submit()
        } else {
            oralRef.current?.submit()
        }
    }

    const steps = (flowType === 'oral' ? ORAL_STEPS : TOPIC_STEPS) as unknown as string[]

    return (
        <WizardShell
            steps={steps}
            activeIndex={1}
            onBack={onBack}
            onNext={handleNext}
            nextLabel="Continuar"
        >
            <Typography
                sx={{
                    fontFamily: "'DM Serif Display', serif",
                    fontSize: 24,
                    fontWeight: 400,
                    color: 'text.primary',
                    mb: '4px',
                }}
            >
                Definições
            </Typography>
            <Typography sx={{ fontSize: 13.5, color: 'text.secondary', mb: '20px' }}>
                Configure os parâmetros da formulação.
            </Typography>

            {/* Tópica / Oral segment */}
            <Box sx={{ mb: '24px' }}>
                <Typography sx={{ fontSize: 13, fontWeight: 500, color: 'text.secondary', mb: '8px' }}>
                    Tipo de formulação
                </Typography>
                <ChoiceChips<FlowType>
                    options={FLOW_OPTIONS}
                    value={flowType}
                    onChange={(v) => {
                        if (model.canEdit) onFlowTypeChange(v)
                    }}
                    sx={{ opacity: model.canEdit ? 1 : 0.5, pointerEvents: model.canEdit ? 'auto' : 'none' }}
                />
            </Box>

            {/* minHeight estável p/ a box não saltar ao alternar Tópica/Oral neste passo */}
            <Box sx={{ minHeight: 360 }}>
                {flowType === 'topic' && (
                    <DefinitionsTopical ref={topicalRef} onBack={onBack} onFinish={onFinish} />
                )}
                {flowType === 'oral' && (
                    <DefinitionsOral ref={oralRef} onBack={onBack} onFinish={onFinish} />
                )}
            </Box>
        </WizardShell>
    )
}
